// extracted by mini-css-extract-plugin
export var hasSubtitle = "Title-module--hasSubtitle--8d680";
export var root = "Title-module--root--7055f";
export var subtitle = "Title-module--subtitle--1bdd6";
export var title = "Title-module--title--aaf16";